module.exports = __webpack_public_path__ + "img/attachment.2883e092.svg";